import { StyledAddVerifierButton } from 'components/v2/buttons';
import { COLLABORATION_REQUEST_SENT_TEXT } from 'components/v2/compiler/constants';
import { Panel } from 'primereact/panel';
import React from 'react';
import styled from 'styled-components';
import { defaultThemeColors } from 'styles/theme';
import { isWithin24Hours } from 'util/utils';

interface CertificationBodyCardProps {
  data: any;
  onSelectBody: any;
  onAddBody: any;
  expanded: boolean;
  buttonsAreDisabled: boolean | undefined;
}

const CertificationBodyCard: React.FunctionComponent<CertificationBodyCardProps> = ({
  data,
  onSelectBody,
  onAddBody,
  expanded,
  buttonsAreDisabled,
}) => {
  const { id, name, email, information, verifierType, requestSentAt, successOperationText, errorText } = data;

  const collaborationRequestDate = !!requestSentAt ? new Date(requestSentAt) : undefined;

  const requestCollaborationButtonDisabledText =
    successOperationText ?? (isWithin24Hours(collaborationRequestDate) ? COLLABORATION_REQUEST_SENT_TEXT : null);

  const headerTemplate = (options: any) => {
    const className = `${options.className} justify-content-space-between w-full`;
    return (
      <div className={className} onClick={options.onTogglerClick}>
        <div>
          <strong style={{ color: defaultThemeColors.primaryBlack }}>{name}</strong>
          <StyledCompanyInfo style={{ marginBottom: 0 }}>{verifierType}</StyledCompanyInfo>
        </div>
      </div>
    );
  };

  const renderContactInformation = () => {
    if (!!information && !!email) {
      return (
        <StyledCompanyInfo className="p-component">
          {information}
          <br />
          {email}
        </StyledCompanyInfo>
      );
    }
    if (!!information && !email) {
      return <StyledCompanyInfo className="p-component">{information}</StyledCompanyInfo>;
    }
    if (!information && !!email) {
      return <StyledCompanyInfo className="p-component">{email}</StyledCompanyInfo>;
    }
    return null;
  };

  return (
    <StyledVerifiedCardPanel
      headerTemplate={(options) => headerTemplate(options)}
      toggleable
      collapsed={!expanded}
      onToggle={onSelectBody}
    >
      <div onClick={onSelectBody}>
        {renderContactInformation()}
        <StyledAddVerifierButton
          label="Add body"
          onClick={(e) => {
            e.stopPropagation();
            onAddBody(id);
          }}
          disabled={buttonsAreDisabled}
        />
        {requestCollaborationButtonDisabledText && (
          <StyledSuccessTextContainer>{requestCollaborationButtonDisabledText}</StyledSuccessTextContainer>
        )}
        {errorText && <StyledErrorTextContainer>{errorText}</StyledErrorTextContainer>}
      </div>
    </StyledVerifiedCardPanel>
  );
};

const StyledVerifiedCardPanel = styled(Panel)`
  border: 1px solid;
  border-color: ${defaultThemeColors.elementsInputBorder};
  border-radius: 2px;
  margin-top: 10px;
  margin-bottom: 10px;

  .p-panel-header {
    border: 0;
    background-color: ${defaultThemeColors.primaryWhite};
    margin-top: 3px;
    ${(props) => props.theme.typography.bodyInput};
  }

  .p-panel-content {
    border: 0;
    background-color: ${defaultThemeColors.primaryWhite};
    ${(props) => props.theme.typography.bodyInput};
    padding-top: 0px;
  }

  p {
    margin-top: 0.5rem;
  }
`;

const StyledSuccessTextContainer = styled.div`
  margin-top: 15px;
  font-size: 10px;
  font-style: italic;
  color: ${defaultThemeColors.primaryGreen};
`;

const StyledErrorTextContainer = styled.div`
  margin-top: 15px;
  color: red;
`;

const StyledCompanyInfo = styled.p`
  ${(props) => props.theme.typography.bodyInput};
`;

export default CertificationBodyCard;
